import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="pt-16 min-h-screen bg-secondary font-montserrat">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="bg-cream rounded-lg shadow-elegant overflow-hidden p-8">
          <h1 className="text-4xl font-bold mb-8 text-secondary font-cormorant-garamond">
            Polityka Prywatności
          </h1>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondaryLight font-cormorant-garamond">
              1. Informacje ogólne
            </h2>
            <p className="text-warmGray mb-4">
              Ta Polityka Prywatności określa zasady przetwarzania i ochrony danych w restauracji Tortuga.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondaryLight font-cormorant-garamond">
              2. Pliki Cookie
            </h2>
            <p className="text-warmGray mb-4">
              Nasza strona wykorzystuje wyłącznie niezbędne pliki cookie, które są konieczne do prawidłowego działania serwisu. Używamy ich do:
            </p>
            <ul className="list-disc pl-6 mb-4 text-warmGray">
              <li>Zapamiętania podstawowych preferencji użytkownika (np. wybór języka)</li>
              <li>Zapewnienia podstawowych funkcjonalności strony</li>
            </ul>
            <p className="text-warmGray mb-4">
              Te pliki cookie są wymagane do działania strony i nie można ich wyłączyć.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-secondaryLight font-cormorant-garamond">
              3. Kontakt
            </h2>
            <p className="text-warmGray mb-4">
              W sprawach związanych z funkcjonowaniem strony możesz się z nami skontaktować:
            </p>
            <ul className="list-disc pl-6 text-warmGray">
              <li>Email: restauracjatortuga@gmail.com</li>

            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;